import {SxProps, Theme} from '@mui/material/styles';

// Main container styles for the Alert component
export const alertSx = (bg: string | undefined, color: string | undefined): SxProps<Theme> => (t) => ({
    backgroundColor: bg,
    color,
    margin: t.spacing(0.5),
    fontSize: t.spacing(1.75),
    width: 'auto',
    minHeight: t.spacing(8),
    display: 'flex',
    alignItems: 'center',
});

// Typography styles for bold + normal spans
export const boldSx: SxProps<Theme> = {fontWeight: 'bold'};
export const normalSx: SxProps<Theme> = {fontWeight: 300};
